import React, { Component } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

class ScrollDetect extends Component {
	ref = React.createRef();

	componentDidMount() {
		const { onVisible } = this.props;

		const observer = new IntersectionObserver(
			entries => {
				entries.forEach(entry => {
					if (entry.isIntersecting) {
						onVisible();
					}
				});
			},
			{
				root: null,
				rootMargin: "0px",
				threshold: 0.5,
			},
		);

		if (this.ref.current) {
			observer.observe(this.ref.current);
		}
	}

	render() {
		const { className, children } = this.props;

		return (
			<div
				ref={this.ref}
				className={classNames("scroll-detect", className)}
			>
				{children}
			</div>
		);
	}
}

ScrollDetect.propTypes = {
	onVisible: PropTypes.func.isRequired,
	className: PropTypes.string,
	children: PropTypes.any,
};

ScrollDetect.defaultProps = {
	className: "",
	children: undefined,
};

export default ScrollDetect;
